import { useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { Box } from "@bca/ui-library";
import styled from "styled-components";
import { layout } from "styled-system";

import PositionedBox from "../StyledComponents/PositionedBox";
import { storeType } from "../redux/store";
import { Vehicle } from "../Interfaces/vehicle.type";
import { Devices, useViewport } from "../Hooks/useViewport.hook";
import MultipleDeliveryHeader from "./MultipleDeliveryHeader";
import SelectedVehicleRow from "./SelectedVehicleRow";
import MultipleDeliveryButtons from "./MultipleDeliveryButtons";

const SlideoutContainer = styled(PositionedBox)`
  ${layout}
  box-shadow: 0px 1px 2px 2px rgba(21, 45, 109, 0.08),
    2px 0px 8px 4px rgba(161, 194, 218, 0.24),
    1px 1px 2px 2px rgba(21, 45, 109, 0.06),
    2px 2px 4px 2px rgba(161, 194, 218, 0.06),
    0px 2px 8px 2px rgba(161, 194, 218, 0.06);
`;

const MultipleDeliverySlideout: any = () => {
  const container = document.body;

  const viewport = useViewport();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleSlideout = () => setIsExpanded((prevState) => !prevState);

  const store = useSelector((state: storeType) => ({
    selectedForDelivery: state.bookDelivery.selectedForDelivery,
    snackbarState: state.snackbar.snackbarState,
  }));

  const flexDirection =
    isExpanded || viewport === Devices.MOBILE ? "column" : "row";

  return createPortal(
    <SlideoutContainer
      position="fixed"
      bottom={store.snackbarState ? "60px" : 0}
      left={0}
      zIndex="999"
      width="100%"
      minHeight="84px"
      maxHeight="80%"
      backgroundColor="primary-white"
      paddingX={{ desktop: "60px", mobile: "20px" }}
      paddingY={5}
      display="flex"
      flexDirection={flexDirection}
      justifyContent="space-between"
    >
      <MultipleDeliveryHeader
        isExpanded={isExpanded}
        handleSlideout={handleSlideout}
      />
      {isExpanded && (
        <Box overflowY="auto" marginBottom={5}>
          {store.selectedForDelivery.map((vehicle: Vehicle) => (
            <SelectedVehicleRow key={vehicle.vrm} vehicle={vehicle} />
          ))}
        </Box>
      )}
      <MultipleDeliveryButtons
        isExpanded={isExpanded}
        handleSlideout={handleSlideout}
      />
    </SlideoutContainer>,
    container
  );
};

export default MultipleDeliverySlideout;
